import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../../assets/css/gcstudent/whychooseus/WhyChooseUs.css";

const features = [
  {
    id: 1,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="feature-icon-svg">
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.8" />
        <path d="M7 8h10M7 12h7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M12 17l2-2-2-2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "Vast Collection",
    desc: "Access thousands of books and digital resources.",
  },
  {
    id: 2,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="feature-icon-svg">
        <circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="16" cy="8" r="2.2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 18c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M16 13c2 0 4 1.2 4 3.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
    title: "Community",
    desc: "Share notes and collaborate with fellow students.",
  },
  {
    id: 3,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="feature-icon-svg">
        <path d="M12 3l1.5 4.5H18l-3.75 2.7 1.5 4.5L12 12l-3.75 2.7 1.5-4.5L6 7.5h4.5L12 3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M12 17v4M9 21h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
    title: "AI Powered",
    desc: "AI-based book summarization and smart recommendations.",
  },
  {
    id: 4,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="feature-icon-svg">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 3a9 9 0 010 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M3 12h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M12 3c-2.5 2.5-3.5 5.5-3.5 9s1 6.5 3.5 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
    title: "24/7 Access",
    desc: "Access digital resources anytime, from anywhere.",
  },
];

const WhyChooseUs = () => {
  const [visible, setVisible] = useState(false);
  const [cardVisible, setCardVisible] = useState([]);
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const sectionObserver = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) sectionObserver.observe(sectionRef.current);

    const cardObservers = features.map((_, i) => {
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setCardVisible((prev) => {
              const updated = [...prev];
              updated[i] = true;
              return updated;
            });
          }
        },
        { threshold: 0.2 }
      );
      if (cardRefs.current[i]) obs.observe(cardRefs.current[i]);
      return obs;
    });

    return () => {
      sectionObserver.disconnect();
      cardObservers.forEach((o) => o.disconnect());
    };
  }, []);

  return (
    <section className="why-section" ref={sectionRef}>
      {/* Background orbs */}
      <div className="why-orb why-orb-1" />
      <div className="why-orb why-orb-2" />

      <Container className="why-container">
        {/* Header */}
        <div className={`why-header ${visible ? "header-animate" : ""}`}>
          <h2 className="why-title">Why Choose Us</h2>
          <p className="why-subtitle">
            What makes GGCW Library the best choice for your academic needs
          </p>
        </div>

        {/* Cards */}
        <Row className="gy-4 justify-content-center">
          {features.map((feature, i) => (
            <Col key={feature.id} xs={12} sm={6} lg={3}>
              <div
                className={`feature-card ${cardVisible[i] ? "card-animate" : ""}`}
                ref={(el) => (cardRefs.current[i] = el)}
                style={{ transitionDelay: `${i * 0.12}s` }}
              >
                <div className="feature-icon-box">
                  {feature.icon}
                </div>
                <h5 className="feature-title">{feature.title}</h5>
                <p className="feature-desc">{feature.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;